import { render, staticRenderFns } from "./CryptogramList.vue?vue&type=template&id=be135de4&"
import script from "./CryptogramList.vue?vue&type=script&lang=js&"
export * from "./CryptogramList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports